import FirebaseLogin from '@/pages/firebase-login';

export default function Landing() {
  return <FirebaseLogin />;
}